import { FirebaseApp, FirebaseOptions, initializeApp } from 'firebase/app'

import { railsContext } from 'Const'

// TODO: Typescript import defer *?
let instance: FirebaseApp
const app = (): FirebaseApp => {
  if (instance) return instance

  let firebaseConfig: FirebaseOptions = {}

  if ('firebaseConfig' in railsContext) {
    firebaseConfig = railsContext.firebaseConfig
  }

  instance = initializeApp(firebaseConfig)

  return instance
}

export { app }
